import { useState } from "react";
import { Mail } from "lucide-react";
import { subscribeToNewsletter } from "../store/actions/newsLetterAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import bgDesktop from "../assets/img/bgImageDesktop.avif";
import bgMobile  from "../assets/img/bgImageMobile.avif";
import leftImage from "../assets/img/leftImage.png";
import rightImage from "../assets/img/rightImage.png";
import fhpIcon   from "../assets/img/fhp_icon.png";

const FHP_URL = "https://fans-help-players-athlete.web.app";

const MainView = () => {
    const [email, setEmail]     = useState("");
    const [loading, setLoading] = useState(false);

    const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

    const handleSubmit = async () => {
        if (!email.trim())        { toast.error("Please enter your email.");               return; }
        if (!isValidEmail(email)) { toast.error("Please enter a valid email address.");    return; }
        setLoading(true);
        await subscribeToNewsletter(email, () => { setLoading(false); setEmail(""); });
    };

    return (
        <div className="fhp-root">

            {/* ══════════ HERO ══════════ */}
            <div className="fhp-hero">

                {/* BG — desktop shown by default, mobile swapped via CSS */}
                <img src={bgDesktop} alt="" className="fhp-bg fhp-bg--desktop" aria-hidden="true" />
                <img src={bgMobile}  alt="" className="fhp-bg fhp-bg--mobile"  aria-hidden="true" />
                <div className="fhp-overlay" aria-hidden="true" />

                {/* Side athletes — absolutely positioned, desktop only */}
                <img src={leftImage}  alt="" className="fhp-athlete fhp-athlete--left"  aria-hidden="true" />
                <img src={rightImage} alt="" className="fhp-athlete fhp-athlete--right" aria-hidden="true" />

                {/* ── Top bar ── */}
                <div className="fhp-topbar">
                    <div className="fhp-brand">
                        <span className="brand-fans">FANS</span>
                        <span className="brand-help">HELP</span>
                        <span className="brand-players">PLAYERS</span>
                    </div>
                    <img src={fhpIcon} alt="FHP" className="fhp-topbar-icon" />
                </div>

                {/* ── Centre content ── */}
                <div className="fhp-center">

                    {/* Already have an account — login buttons */}
                    <div className="fhp-login-row">
                        <span className="fhp-login-label">Already have an account?</span>
                        <div className="fhp-login-btns">
                            <a
                                href="https://fans-help-players-athlete.web.app/auth/loginathlete"
                                className="fhp-login-btn fhp-login-btn--athlete"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Athlete Login
                            </a>
                            <a
                                href="https://fhp-fans.web.app/"
                                className="fhp-login-btn fhp-login-btn--fan"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Fan Login
                            </a>
                        </div>
                    </div>

                    <h1 className="fhp-headline">
                        <span className="hl-white">REAL ATHLETES.</span>
                        <span className="hl-blue">REAL ACCESS.</span>
                        <span className="hl-red">REAL IMPACT.</span>
                    </h1>

                    <p className="fhp-subtext">
                        FansHelpPlayers.com is the ultimate NIL platform
                        connecting fans with student-athletes
                        across 20+ sports nationwide.
                    </p>

                    <a href={FHP_URL} className="fhp-enter-btn" target="_blank" rel="noopener noreferrer">
                        <img src={fhpIcon} alt="FHP" className="fhp-enter-icon" />
                        <span className="fhp-enter-label">ENTER FHP</span>
                        <span className="fhp-enter-arrow">→</span>
                    </a>

                    <div className="fhp-newsletter">
                        <p className="fhp-nl-title">Subscribe to our newsletter to stay updated</p>
                        <div className="fhp-nl-row">
                            <div className="fhp-input-wrap">
                                <span className="fhp-mail-icon"><Mail size={18} /></span>
                                <input
                                    type="email"
                                    className="fhp-email-input"
                                    placeholder="Your Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <button className="fhp-submit-btn" onClick={handleSubmit} disabled={loading}>
                                {loading
                                    ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                    : "Submit"}
                            </button>
                        </div>
                    </div>

                    {/* NO 3rd Party Deals — below newsletter */}
                    <div className="fhp-no3rd">
                        <strong>NO 3rd Party Deals</strong>
                        <strong>Over $599</strong>
                    </div>
                </div>

            </div>

            {/* ══════════ FOOTER ══════════ */}
            <div className="fhp-footer">
                <div className="fhp-footer-inner">

                    <div className="fhp-footer-item">
                        <div className="fhp-badge fhp-badge--blue">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
                                <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                            </svg>
                        </div>
                        <div className="fhp-footer-text">
                            <strong>SUPPORT ATHLETES</strong>
                            <p>Empower student-athletes through NIL opportunities.</p>
                        </div>
                    </div>

                    <div className="fhp-footer-item fhp-footer-item--right">
                        <div className="fhp-badge fhp-badge--red">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
                                <path d="M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6-2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm6 16H6V8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h4v2c0 .55.45 1 1 1s1-.45 1-1V8h2v12z" />
                            </svg>
                        </div>
                        <div className="fhp-footer-text">
                            <strong>SHOP NIL MERCH</strong>
                            <p>Buy official athlete merchandise and digital collectibles.</p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
};

export default MainView;
